const initialState = () => ({
  action: null,
  isOpened: false,
  type: null,
  size: null,
  data: [],
  loading: false,
  error: null,
  onSuccessCallback: null
});

const ACTION_KEY = 'SAVE_UPDATE_STEPS_MODAL';

const reducer = (state = initialState(), reduxAction) => {
  switch (reduxAction.type) {
    case `${ACTION_KEY}_OPEN`: {
      const { action, data, type, onSuccessCallback } = reduxAction.payload;
      return {
        ...state,
        data,
        action,
        type,
        size: data.size,
        onSuccessCallback,
        isOpened: true
      };
    }
    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: reduxAction.payload
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      return initialState();
    }
    case `${ACTION_KEY}_NOTIFICATION_SHOW`: {
      return {
        ...state,
        error: reduxAction.payload
      };
    }
    case `${ACTION_KEY}_NOTIFICATION_HIDE`: {
      return {
        ...state,
        error: null
      };
    }
    default:
      return state;
  }
};

export default reducer;
